export const Label = {
  CALLS: 'CALLS',
  CHATS: 'CHATS',
  DIRECTORY: 'DIRECTORY',
  RECENT: 'RECENT',
  ROOMS: 'ROOMS',
  SETTINGS: 'SETTINGS',
} as const satisfies Record<Uppercase<string>, Uppercase<string>>
